/* js/footerMain.js */


jQuery(document).ready(function ($) {
    // var footHeight = $('.footerMain').outerHeight();
    var footHeight = $( window ).height();




    $('.footerSpace').css('height', footHeight);
    //$('.footerMain__inner').css('height', footHeight);
});


